// Admin i18n: the shared machinery lives in @booking/core-ui/i18n; only the
// dictionaries are per-vertical. Register them once at module load, then
// re-export the shared context so the rest of admin keeps importing from
// "./i18n/context" unchanged.
import { registerDictionaries } from "@booking/core-ui/i18n";
import ja from "./ja";
import en from "./en";

registerDictionaries({ ja, en });

export * from "@booking/core-ui/i18n";
